// env=live
/* eslint-disable */

const env = {
    'feedBaseUrl': '//notifications.files.bbci.co.uk/',
    'feedAggregatedInitialFeed': 'latest.json',
    'feedTopicInitialFeed': 'latest.json',
    'feedTopicMaxSubscriptions': 12,
    'preferencesUrls': {
        'get': 'https://preferences.notifications.api.bbc.co.uk/subscriptions',
        'postPreference': 'https://preferences.notifications.api.bbc.co.uk/preference',
        'postPreferenceRelay': 'https://preferences.notifications.api.bbc.co.uk/preference/relay',
        'idcta': 'https://ssl.bbc.co.uk/idcta/init'
    },
    'under13s': {
        'moreInfo': 'http://www.bbc.co.uk/usingthebbc/account/what-are-child-permissions/'
    },
    'idcta': {
        'urls': {
            'signin': 'https://ssl.bbc.co.uk/id/signin',
            'register': 'https://ssl.bbc.co.uk/id/register'
        }
    },
    'uas': {
        'apiKey': 'g1elnjronnmcc',
        'env': 'live'
    },
    'aroundBBCUrls': {
      'usingTheBBC': 'http://www.bbc.co.uk/usingthebbc/',
      'iplayer': 'http://www.bbc.co.uk/iplayer',
      'musicArtists': 'http://www.bbc.co.uk/music/artists/popular/viewed',
      'musicPlaylists': 'http://www.bbc.co.uk/music/playlists/featured',
      'myProgrammes': 'http://www.bbc.co.uk/iplayer/added',
      'myArtists': 'https://www.bbc.co.uk/music/artists/my',
      'myPlaylists': 'https://www.bbc.co.uk/music/playlists/my'
    },
    'notificationsPollingInterval': 600000,
    'preferencesPollingInterval': 600000,
    'lockExpiry': 30000,
    'cacheTimeout': 600000,
    'visibleChunkAmount': 10,
    'maxNotificationAge': 5
};

module.exports = { env };



/** WEBPACK FOOTER **
 ** ./assets/js/config.js
 **/